import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/motor-control/Motor Control_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/motor-control/Motor Control_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/motor-control/Motor Control_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/motor-control/Motor Control_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/motor-control/Motor Control_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/motor-control/Motor Control_Slider_6.jpg';

import Data_MotorControl from './Data_MotorControl';

function Work_MotorControl() {
    return (
        <>
            <DetailedHeader
                heading="Building Job-Ready Electrical Skills Safely"
                client="NETCO"
                service="Virtual Reality"
                date="2025"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=y5LDVseL2n4"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_MotorControl.content}
        </>
    );
}

export default Work_MotorControl;
